


















































































































import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';
import SinglePage from '@components/SinglePage';
import request from '@/utils/request';
import { dialogObj, tipsDialog, closeDialog } from '@/useable/dialog';
import { isCore } from '@/useable/login';
import { Message } from 'element-ui';

export default defineComponent({
  name: 'Supply',
  components: { SinglePage },
  setup() {
    const pageLoading = ref(true);
    const tableLoading = ref(true);
    const ruleForm = ref(null);

    // 搜索表单配置
    const searchFormOptions = reactive({
      form: {
        supplierName: '',
        contact: '',
        cellPhone: '',
        workEmail: '',
        registerTime: '',
        inviteTime:'',
        registerStatus: '',
        isValid: '',
      },
      formColumn: [
        {
          name: 'supplierName',
          type: 'input',
          label: '供应商名称：',
          disabled: false,
          placeholder: '输入供应商名称',
        },
        {
          name: 'contact',
          type: 'input',
          label: '联系人：',
          placeholder: '输入联系人姓名',
        },
        {
          name: 'cellPhone',
          type: 'input',
          label: '手机号：',
          placeholder: '输入联系人手机号',
        },
        {
          name: 'workEmail',
          type: 'input',
          label: '邮箱：',
          placeholder: '输入联系人邮箱',
        },
        {
          name: 'registerTime',
          type: 'date',
          label: '注册时间：',
          placeholder: '选择时间',
        },
        {
          name: 'inviteTime',
          type: 'date',
          label: '邀请时间：',
          placeholder: '选择时间',
        },
        {
          name: 'registerStatus',
          type: 'select',
          label: '注册情况：',
          placeholder: '',
          options: [
            {
              value: '',
              name: '全部',
            },
            {
              value: '0',
              name: '未注册',
            },
            {
              value: '1',
              name: '已注册',
            },
            {
              value: '2',
              name: '已停用',
            },
          ],
        },
        {
          name: 'isValid',
          type: 'select',
          label: '供应商状态：',
          placeholder: '',
          options: [
            {
              value: '',
              name: '全部',
            },
            {
              value: '0',
              name: '无效',
            },
            {
              value: '1',
              name: '有效',
            }
          ],
        },
      ]
    });

    // 表格数据初始化
    const tableData = ref([]);
    const columns = ref([
      {
        label: '供应商名称',
        key: 'supplierName',
        width: 120
      },
      {
        label: '企业税号',
        key: 'supplierCertId',
      },
      {
        label: '联系人',
        key: 'contact',
        width: 120
      },
      {
        label: '手机号',
        key: 'cellPhone',
        width: 140
      },
      {
        label: '邮箱',
        key: 'workEmail',
        width: 220
      },
      {
        label: '供应商状态',
        key: 'isValid',
        width: 110
      },
      {
        label: '注册情况',
        key: 'registerStatus',
      },
      {
        label: '邀请时间',
        key: 'inviteTime',
        width: 170
      },
      {
        label: '注册时间',
        key: 'registerTime',
        width: 170
      },
      {
        label: '入池时间',
        key: 'inPoolTime',
        width: 170
      },
    ]);

    // 分页数据
    const paginationOptions = reactive({
      size: 10,
      current: 1,
      total: 0,
    });

    // 手机号校验
    const validateNum = (rule, value, callback) => {
      const phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phone.test(value) && value) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    // 编辑表单校验
    const rules = {
      contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      contactPhone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validateNum, trigger: ['blur', 'change'] },
      ],
      contactEmail: [
        { required: true, message: '请输入工作邮箱', trigger: 'blur' },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change'],
        },
      ],
    };

    // 格式化表单数据
    const defaultFormData = reactive({
      id: '',
      contact: '',
      contactPhone: '',
      contactEmail: '',
    });

    // 表单数据
    const dialogFormData = reactive({
      id: '',
      contact: '',
      contactPhone: '',
      contactEmail: '',
    });
    // const btnStatus = ref(true);

    // 获取表格数据方法
    const getTableData = async (queryParams) => {
      tableLoading.value = true;
      const res = await request('supply', 'supplierInfoList', queryParams);
      if (res?.code === 2000) {
        tableData.value = res.data.records;
        paginationOptions.total = res.data.total;
        paginationOptions.current = res.data.current;
        tableLoading.value = false;
      }
    };

    const listCallback = async () => {
      await getTableData(Object.assign(searchFormOptions.form, {size: paginationOptions.size, current: paginationOptions.current}));
    };

    // 复选框选中值
    const multipleSelection = ref([]);

    // 是否能编辑邮箱
    const isEditMail = ref(false);

    // 数据表格配置
    const tableOptions = reactive({
      tableData,
      columns,
      showSelection: true,
      showEditColumn: true,
      btnsWidth: '110',
      tableLoading,
      getTableData,
      handleSelectionChange: (val) => {
        multipleSelection.value = val;
      }
    });

    // 打开编辑弹框
    const onEdit = (data) => {
      console.log('data', data);
      if (data.registerStatus==='0') {
        isEditMail.value=true;
      } else {
        isEditMail.value=false;
      }
      // btnStatus.value=true;
      dialogObj.type = 'edit';
      dialogObj.title = '编辑供应商信息';
      dialogObj.btnText = '保存';
      dialogFormData.id = data.id;
      dialogFormData.contact = data.contact;
      dialogFormData.contactPhone = data.cellPhone;
      dialogFormData.contactEmail = data.workEmail;
      dialogObj.state = true;
    };

    // 提交编辑
    const editSubmit = async (params) => {
      if (!isEditMail.value) {
        delete params.contactEmail;
      }
      const res = await request('supply', 'editSupplierInfo', params);
      if (res.code === 2000) {
        tipsDialog.showDialog = true;
        tipsDialog.text = '编辑已保存！';
        tipsDialog.icon = 'el-icon-success';
        tipsDialog.btns = ['confirm'];
        dialogObj.state = false;
      }
      listCallback();
    };
    
    const sendMails = async () => {
      if (!multipleSelection.value.length) {
        Message.error('请选择需要发送邮件的供应商');
        return;
      }
      const hasRegisterSupplier = multipleSelection.value.filter((item: any) => item.registerStatus === '1' || item.registerStatus === '2');
      if (hasRegisterSupplier.length) {
        Message.error('您选择的供应商中有已注册或已停用的供应商，不允许发送邀请邮件，请重新选择');
        return;
      }
      const sendMsgList = multipleSelection.value.map((item: any) => {
        return {
          workEmail: item.workEmail,
          supplierId: item.id
        };
      });

      const res = await request('login', 'sendMail', { sendMsgList, type: 'reg' });
      if (res.code === 2000) {
        tipsDialog.icon = 'el-icon-success';
        tipsDialog.text = '邮件已发送！';
        tipsDialog.btns = ['confirm'];
        tipsDialog.showDialog = true;
      }
    };

    const toggleAccount = async (type: string) => {
      if (!multipleSelection.value.length) {
        Message.error('请选择需要发送邮件的供应商');
        return;
      }

      if (!multipleSelection.value.every((item: any) => item.registerStatus !== '0')) {
        Message.error('您选择的供应商中有尚未完成注册的供应商，请重新选择');
        return;
      }

      const res = await request('supply', 'supplierInfoStop', {
        ids: multipleSelection.value.map((item: any) => item.id),
        start: type === 'start' ? 'start' : ''
      });

      if (res.code === 2000) {
        tipsDialog.icon =  type === 'start' ?  'el-icon-success' : 'el-icon-warning';
        tipsDialog.text = type === 'start' ? '供应商账号已重新启用！': '供应商账号已停用！';
        tipsDialog.btns = ['confirm'];
        tipsDialog.showDialog = true;
        await listCallback();
      }
    };

    onMounted(() => {
      listCallback();
      pageLoading.value = false;
    });

    return {
      pageLoading,
      searchFormOptions,
      tableOptions,
      paginationOptions,
      listCallback,
      // 页面数据&方法
      tipsDialog,
      isCore,
      sendMails,
      toggleAccount,
      onEdit,
      dialogObj,
      dialogFormData,
      rules,
      closeDialog,
      defaultFormData,
      validateNum,
      editSubmit,
      // btnStatus,
      isEditMail,
      ruleForm
    };
  }
});
